module.exports = __webpack_public_path__ + "static/img/cont39_03.af0f3e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont39_03.png
// module id = gCl0
// module chunks = 0